import type { IVirtualizedTreeNode } from "@voltalis/ui-kit/components";

import { TSiteSectionsTreeData } from "@/app/tools/new-section-management/site-sections-tree/site-sections-tree.types";
import { ProgrammableAppliance, SectionNode } from "@/domains/v4b/site-section/site-section.types";

export const MoveSectionAppliancesWizardInject = Symbol("MoveSectionAppliancesWizardInject");

export interface IMoveSectionAppliancesWizardInject {
  selectedAppliances: ProgrammableAppliance[];
  initialSelectedSection: SectionNode;
  siteSectionsTree?: IVirtualizedTreeNode<TSiteSectionsTreeData>;
  selectedTargetSection?: SectionNode;
}
